/* Minimal ES + DE translations. When a key is missing in ES or DE, it falls back
 * to English (dict.en) then French (dict.fr). See i18n.js `t()`. */
export const dictES = {
  brand_tagline: "Descubre primero. Postúlate después.",
  hero_title: "El mercado laboral oculto, revelado.",
  hero_sub: "Proxijob invierte la búsqueda de empleo: explora las empresas locales en un mapa mundial, deja que nuestra IA analice tu titulación y postula espontáneamente en un clic.",
  cta_explore: "Explorar el mapa",
  cta_signup: "Crear una cuenta",
  cta_login: "Iniciar sesión",
  nav_map: "Mapa",
  nav_suggestions: "Sugerencias IA",
  nav_internships: "Prácticas",
  nav_applications: "Mis postulaciones",
  nav_favorites: "Favoritos",
  nav_profile: "Perfil",
  nav_company: "Espacio empresa",
  nav_admin: "Admin",
  nav_pricing: "Tarifas",
  nav_roadmap: "Roadmap",
  logout: "Cerrar sesión",
  login_title: "Bienvenido de nuevo",
  login_sub: "Inicia sesión para descubrir empresas cerca de ti.",
  register_title: "Únete a Proxijob",
  register_sub: "Crea tu cuenta de candidato en 30 segundos.",
  email: "Email",
  password_label: "Contraseña",
  name: "Nombre completo",
  or: "o",
  continue_google: "Continuar con Google",
  account_type: "Tipo de cuenta",
  candidate: "Candidato",
  company: "Empresa",
  no_account: "¿Aún no tienes cuenta?",
  have_account: "¿Ya tienes cuenta?",
  filter_sector: "Sector",
  filter_country: "País",
  filter_city: "Ciudad",
  filter_internship: "Recibe becarios",
  filter_students: "Empleos para estudiantes",
  filter_contract: "Tipo de contrato",
  filter_reset: "Restablecer",
  contract_stage: "Prácticas",
  contract_emploi: "Empleo",
  contract_saisonnier: "Temporal",
  contract_alternance: "Formación dual",
  all_contracts: "Todos los tipos",
  all_sectors: "Todos los sectores",
  all_countries: "Todos los países",
  all_cities: "Todas las ciudades",
  companies_found: "empresas encontradas",
  match_score: "coincidencia",
  apply_spontaneous: "Candidatura espontánea",
  send: "Enviar",
  cancel: "Cancelar",
  application_sent: "¡Candidatura enviada!",
  analyzing: "Analizando…",
  save: "Guardar",
  empty_map: "Ninguna empresa coincide con tus filtros.",
  footer_note: "Proxijob — Cobertura mundial, despliegue progresivo.",
  locate_me: "Localízame",
  locate_denied: "Geolocalización denegada por el navegador",
  radius: "Radio",
  km: "km",
  center_set: "Centro establecido",
  gallery: "Galería",
  team: "Equipo",
  news: "Noticias",
  diploma: "Titulación",
  specialty: "Especialidad",
  skills: "Habilidades (separadas por comas)",
  upload_cv: "Subir mi CV (PDF)",
  hosts_interns_yes: "Recibe becarios regularmente",
  matched_sectors: "Sectores recomendados",
  recommended_companies: "Empresas recomendadas",
  roadmap_title: "Roadmap Estudios + Primer Empleo",
  roadmap_placeholder: "¿Qué profesión te apasiona? (ej: Cocinero, Programador, Diseñador)",
  roadmap_level_placeholder: "Tu nivel actual (opcional)",
  roadmap_go: "Trazar mi roadmap",
};

export const dictDE = {
  brand_tagline: "Erst entdecken. Dann bewerben.",
  hero_title: "Der verborgene Jobmarkt, sichtbar gemacht.",
  hero_sub: "Proxijob dreht die Jobsuche um: erkunde lokale Unternehmen auf einer Weltkarte, lass unsere KI deinen Abschluss abgleichen und bewirb dich in einem Klick.",
  cta_explore: "Karte erkunden",
  cta_signup: "Konto erstellen",
  cta_login: "Anmelden",
  nav_map: "Karte",
  nav_suggestions: "KI-Vorschläge",
  nav_internships: "Praktika",
  nav_applications: "Meine Bewerbungen",
  nav_favorites: "Favoriten",
  nav_profile: "Profil",
  nav_company: "Unternehmensbereich",
  nav_admin: "Admin",
  nav_pricing: "Preise",
  nav_roadmap: "Roadmap",
  logout: "Abmelden",
  login_title: "Willkommen zurück",
  login_sub: "Melde dich an, um Unternehmen in deiner Nähe zu entdecken.",
  register_title: "Bei Proxijob mitmachen",
  register_sub: "Erstelle dein Kandidatenkonto in 30 Sekunden.",
  email: "E-Mail",
  password_label: "Passwort",
  name: "Vollständiger Name",
  or: "oder",
  continue_google: "Mit Google fortfahren",
  account_type: "Kontotyp",
  candidate: "Kandidat·in",
  company: "Unternehmen",
  no_account: "Noch kein Konto?",
  have_account: "Schon ein Konto?",
  filter_sector: "Branche",
  filter_country: "Land",
  filter_city: "Stadt",
  filter_internship: "Nimmt Praktikanten auf",
  filter_students: "Studentenjobs / Sommerjobs",
  filter_contract: "Vertragsart",
  filter_reset: "Zurücksetzen",
  contract_stage: "Praktikum",
  contract_emploi: "Anstellung",
  contract_saisonnier: "Saisonarbeit",
  contract_alternance: "Duales Studium",
  all_contracts: "Alle Vertragsarten",
  all_sectors: "Alle Branchen",
  all_countries: "Alle Länder",
  all_cities: "Alle Städte",
  companies_found: "Unternehmen gefunden",
  match_score: "Übereinstimmung",
  apply_spontaneous: "Initiativbewerbung",
  send: "Senden",
  cancel: "Abbrechen",
  application_sent: "Bewerbung gesendet!",
  analyzing: "Analysiere…",
  save: "Speichern",
  empty_map: "Keine Unternehmen entsprechen deinen Filtern.",
  footer_note: "Proxijob — Weltweite Abdeckung, schrittweiser Rollout.",
  locate_me: "Lokalisieren",
  locate_denied: "Geolokalisierung vom Browser abgelehnt",
  radius: "Radius",
  km: "km",
  center_set: "Zentrum festgelegt",
  gallery: "Galerie",
  team: "Team",
  news: "Neuigkeiten",
  diploma: "Abschluss",
  specialty: "Fachrichtung",
  skills: "Fähigkeiten (durch Kommas getrennt)",
  upload_cv: "Meinen Lebenslauf hochladen (PDF)",
  hosts_interns_yes: "Nimmt regelmäßig Praktikanten auf",
  matched_sectors: "Empfohlene Branchen",
  recommended_companies: "Empfohlene Unternehmen",
  roadmap_title: "Roadmap Studium + Erster Job",
  roadmap_placeholder: "Welcher Beruf begeistert dich? (z.B. Koch, Programmierer, Designer)",
  roadmap_level_placeholder: "Dein aktuelles Niveau (optional)",
  roadmap_go: "Meine Roadmap zeichnen",
};
